import { HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
interface IBuilder {
	withClientId(): this;
	withUserAndPassword(): this;
	getHeaders(): HttpHeaders;
}

export class HttpHeadersBuilder implements IBuilder {
	private httpHeaders: HttpHeaders;

	constructor() {
		this.httpHeaders = new HttpHeaders();
	}

	public withClientId(): this {
		this.httpHeaders = this.httpHeaders.set(
			'X-IBM-Client-Id',
			environment.clientID
		);
		return this;
	}

	public withUserAndPassword(): this {
		this.httpHeaders = this.httpHeaders.set('usuario', 'CMVAPLICACIONES');
		this.httpHeaders = this.httpHeaders.set(
			'contrasena',
			'B68571606C88ECB993E6B983C27A61'
		);
		return this;
	}

	public withChannelId(): this {
		this.httpHeaders = this.httpHeaders.set('X-Channel-Id', 'ONB');
		return this;
	}

	public withChannelIdGd(): this {
		this.httpHeaders = this.httpHeaders.set('X-Channel-Id', 'GD');
		return this;
	}

	public getHeaders(): HttpHeaders {
		return this.httpHeaders;
	}
}
